import styled from "styled-components";

export const Wrap = styled.div`
  &.active {
    height: auto !important;
  }

  &.single .inner-settings__item {
    width: 100%;
    margin-right: 0;
  }

  @media (min-width: 990px) {
    position: sticky;
    top: 108px;
    background: #fff;
    z-index: 3;
    margin: 0;
    padding-top: 15px;
    padding-right: 16px;
    padding-bottom: 16px;
    padding-left: 16px;
    box-shadow: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  &.active .inner-settings {
    top: 58px;
  }

  @media (min-width: 990px) {
    &.account {
      top: 65px;
    }

    &.single .inner-settings__item {
      width: 50%;
    }
  }
`;

export const Inner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: -24px;
  margin-left: -24px;
  padding-top: 10px;
  padding-bottom: 30px;
  padding-left: 24px;
  padding-right: 24px;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);

  &.sticky {
    position: fixed;
    z-index: 2;
    top: 140px;
    width: 100%;
    background: #fff;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);
  }

  > button {
    position: absolute;
    width: 24px;
    height: 24px;
    padding: 0;
    bottom: 2px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  @media (max-width: 989px) {
    position: fixed;
    z-index: 8;
    top: 140px;
    width: 100%;
    background: #fff;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 990px) {
    position: static;
    display: flex;
    align-items: center;
    margin-right: 0;
    margin-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    box-shadow: none;

    > button {
      display: none;
    }
  }
`;

export const ToggleButton = styled.button`
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  &.active {
    transform: translate(-50%, 0) rotate(180deg);
  }
`;
